<template>
  <div>
    <el-dialog
      title="会员详情"
      :visible.sync="value"
      width="40%"
      :before-close="gopenMemberDialogClose"
      :close-on-click-modal="false"
    >
      <div class="clearfix">
        <div class="leftDiv" style="float: left">
          <div class="dialog-div">
            <span class="title-span">会 员 卡 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hySeeParams.memberCardSn"
              disabled
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">会 员 姓 名:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hySeeParams.memberName"
              disabled
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span"
              >手&nbsp;&nbsp;&nbsp;机&nbsp;&nbsp;&nbsp;号:</span
            >
            <el-input
              size="small"
              class="title-select"
              v-model="hySeeParams.memberMobile"
              disabled
            ></el-input>
          </div>
          <div class="dialog-div">
            <span class="title-span">出 生 日 期:</span>
            <el-date-picker
              type="date"
              size="small"
              class="title-select"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              v-model="hySeeParams.memberBirthday"
              disabled
            ></el-date-picker>
          </div>
          <div class="dialog-div">
            <span class="title-span">身 份 证 号:</span>
            <el-input
              size="small"
              class="title-select"
              v-model="hySeeParams.memberSfnum"
              disabled
            ></el-input>
          </div>
        </div>
        <div class="rightDiv" style="float: left">
          <div class="dialog-div">
            <span class="title-span">会 员 照 片:</span>
            <div>
              <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-div clearfix" v-if="honours.length > 0">
        <span class="title-span" style="float: left">会 员 荣 誉:</span>
        <el-checkbox-group
          v-model="honours"
          size="mini"
          style="float: left; margin-left: 20px"
        >
          <el-checkbox-button
            v-for="item in vipHonor"
            :label="item.id"
            :key="item.id"
            >{{ item.honourName }}
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">会 员 备 注:</span>
        <el-input
          type="textarea"
          style="float: left; margin-left: 20px; width: 600px; margin-top: 10px"
          v-model="hySeeParams.remark"
          disabled
        ></el-input>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span">当 前 等 级:</span>
        <el-select
          clearable
          v-model="hySeeParams.levelId"
          placeholder="请选择会员等级"
          size="small"
          class="title-select"
          disabled
        >
          <el-option
            v-for="item in djSelectList"
            :key="item.id"
            :label="item.cardName"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div clearfix">
        <div style="width: 33%; float: left">
          <span>积分:{{ hySeeParams.points }}</span>
        </div>
        <div style="width: 33%; float: left">
          <span>储值金额(元):{{ hySeeParams.balance }}</span>
        </div>
        <div style="width: 33%; float: left">
          <span>能量值:{{ hySeeParams.power }}</span>
        </div>
      </div>
      <div class="dialog-div clearfix">
        <div style="width: 33%; float: left">
          <span>箭票(组):{{ hySeeParams.arrowTicket }}</span>
        </div>
        <div style="width: 33%; float: left">
          <span>赠送储值(元):{{ hySeeParams.giveStore }}</span>
        </div>
        <div style="width: 33%; float: left">
          <span>电子卡(组):{{ hySeeParams.electronicCard }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="gopenMemberDialogClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAntMemberById,
  getMembersCardLevelSelect,
  getHonourList,
} from "../../api/BusinessManagement";
import { globelurl, posturl } from "../../api/axios";
export default {
  name: "pkIn",
  props: {
    value: {
      type: Boolean,
    },
    memberId: {
      type: String,
    },
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.info();
        }
      },
    },
  },
  data() {
    return {
      vipHonor: [],
      djSelectList: [],
      creatImageUrl: "",
      honours: [],
      hySeeParams: {
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        shopId: "",
        levelId: "",
        balance: "",
        giveStore: "",
        electronicCard: "",
        photoData: "",
        createUserId: "",
        points: "",
        power: "",
        arrowTicket: "",
        electronicCardDays: "",
        honourIds: "",
        remark: "",
        // points: "",
        // balance: "",
        // power: "",
        // arrowTicket: "",
        // giveStore: "",
        // electronicCard: "",
      },
    };
  },
  mounted() {
    this.getHonourList();
    this.getMembersCardLevelSelect();
  },
  methods: {
    info() {
      getAntMemberById({ id: this.memberId }).then((res) => {
        console.log(res);
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.hySeeParams.memberCardSn = res.data.result.memberCardSn;
            this.hySeeParams.memberName = res.data.result.memberName;
            this.hySeeParams.memberMobile = res.data.result.memberMobile;
            this.hySeeParams.memberBirthday = res.data.result.memberBirthday;
            this.hySeeParams.memberSfnum = res.data.result.memberSfnum;
            this.hySeeParams.levelId = res.data.result.antMembersCardLevel.id;
            this.hySeeParams.remark = res.data.result.remark;
            this.hySeeParams.points = res.data.result.points;
            this.hySeeParams.balance = res.data.result.balance;
            this.hySeeParams.power = res.data.result.power;
            this.hySeeParams.arrowTicket = res.data.result.arrowTicket;
            this.hySeeParams.giveStore = res.data.result.giveStore;
            this.hySeeParams.electronicCard = res.data.result.electronicCard;
            this.creatImageUrl = globelurl + res.data.result.photoData;
            this.honours = res.data.result.honourIds
              ? res.data.result.honourIds.split(",")
              : [];
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    gopenMemberDialogClose() {
      this.$emit("gopenMemberDialogClose", false);
      this.hySeeParams = {
        memberName: "",
        memberMobile: "",
        memberBirthday: "",
        memberSfnum: "",
        shopId: "",
        levelId: "",
        balance: "",
        giveStore: "",
        electronicCard: "",
        photoData: "",
        createUserId: "",
        points: "",
        power: "",
        arrowTicket: "",
        electronicCardDays: "",
        honourIds: "",
        remark: "",
        // points: "",
        // balance: "",
        // power: "",
        // arrowTicket: "",
        // giveStore: "",
        // electronicCard: "",
      };
      (this.creatImageUrl = ""), (this.honours = []);
    },
    //荣誉列表
    getHonourList() {
      getHonourList().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.vipHonor = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //获取会员等级下拉列表
    getMembersCardLevelSelect() {
      getMembersCardLevelSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.djSelectList = res.data.result;
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.title-span {
  font-size: 16px;
}

.avatar {
  width: 178px;
  height: 178px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.dialog-div {
  margin: 20px 0;
}

.out-button {
  margin-top: 20px;
  margin-right: 80px;
  margin-bottom: 20px;
}

.leftDiv {
  width: 50%;
  display: inline-block;
}

.rightDiv {
  width: 50%;
  padding-left: 50px;
  display: inline-block;
}
</style>

<style>
.el-dialog__body {
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>

